// @flow
import React from 'react';
import platform from 'platform';
import last from 'lodash/last';
import keycodes from '../../utils/keycodes';

import { singletonTrackPlayer } from '../../utils/audio';

type Props = {
  conversationRequested?: Boolean,
  conversationStarted?: Boolean,
  dispatchSpeakerChangeMutation: Function,
  enterInsertSpeakerNameMode: Function,
  enterUpdateAudioSourceMode: Function,
  exitInsertSpeakerNameMode: Function,
  exitUpdateAudioSourceMode: Function,
  insertSpeakerName: Function,
  insertSpeakerNameMode: Boolean,
  mergeTranscript: Function,
  scribeCreateTranscript: Function,
  scribeDeselectTranscriptWord: Function,
  scribeEnterSearchMode: Function,
  scribeSelectTranscriptWord: Function,
  selectedTranscriptIndex: number,
  selectedWordIndex: number,
  splitTranscript: Function,
  status: Object,
  transcriptsCurrent: Array<string>,
  updateAudioSourceMode: boolean,
  updateSpeakerListened: Function,
};

const isMac = platform.os.family === 'OS X';

export default class ScribeTranscriptList extends React.Component<Props> {
  handleKeydown = (ev: KeyboardEvent) => {
    const {
      conversationRequested,
      conversationStarted,
      dispatchSpeakerChangeMutation,
      enterInsertSpeakerNameMode,
      enterUpdateAudioSourceMode,
      exitUpdateAudioSourceMode,
      exitInsertSpeakerNameMode,
      insertSpeakerName,
      insertSpeakerNameMode,
      mergeTranscript,
      scribeCreateTranscript,
      scribeDeselectTranscriptWord,
      scribeEnterSearchMode,
      scribeSelectTranscriptWord,
      selectedTranscriptIndex,
      selectedWordIndex,
      splitTranscript,
      status,
      transcriptsCurrent,
      updateAudioSourceMode,
      updateSpeakerListened,
    } = this.props;

    const key = keycodes(ev);
    if (key.ESC) {
      ev.preventDefault();
      ev.stopPropagation();
      // deselect, dont commit whatever was changed
      scribeDeselectTranscriptWord({ skipCommit: true });
      if (insertSpeakerNameMode) exitInsertSpeakerNameMode();
      if (updateAudioSourceMode) exitUpdateAudioSourceMode();
    } else if (key.CTRL && key.COMMA) {
      ev.preventDefault();
      ev.stopPropagation();
      scribeEnterSearchMode();
    } else if (key.TAB) {
      if (insertSpeakerNameMode) exitInsertSpeakerNameMode();
      if (updateAudioSourceMode) exitUpdateAudioSourceMode();
      if (selectedWordIndex === undefined) {
        return;
      }
      ev.preventDefault();
      ev.stopPropagation();

      scribeSelectTranscriptWord(
        {
          index: selectedWordIndex,
          indexTranscript: selectedTranscriptIndex,
          direction: key.SHIFT ? -1 : 1,
          skipCreateNextBloc: true,
        },
        { src: `${key.SHIFT ? 'SHIFT_' : ''}TAB_KEYPRESS` }
      );
    } else if ((!isMac && key.CTRL && key.SHIFT && key.RETURN) || (isMac && key.META && key.SHIFT && key.RETURN)) {
      const lastIdTranscript = last(transcriptsCurrent) ? last(transcriptsCurrent) : 0;
      scribeCreateTranscript(lastIdTranscript);
      if (insertSpeakerNameMode) exitInsertSpeakerNameMode();
    } else if ((!isMac && key.CTRL && ev.key === 'x') || (isMac && key.META && ev.key === 'x')) {
      ev.preventDefault();
      ev.stopPropagation();
      enterInsertSpeakerNameMode();
    } else if ((!isMac && key.CTRL && ev.key === 'y') || (isMac && key.META && ev.key === 'y')) {
      ev.preventDefault();
      ev.stopPropagation();
      enterUpdateAudioSourceMode();
    } else if (
      (!isMac && key.CTRL && !key.SHIFT && ev.code.includes('Digit')) ||
      (isMac && key.META && !key.SHIFT && ev.code.includes('Digit'))
    ) {
      ev.preventDefault();
      ev.stopPropagation();
      let index = parseInt(ev.code.split('Digit')[1], 10);
      if (key.ALT) {
        index += 9;
      }
      if (insertSpeakerNameMode) {
        insertSpeakerName(index - 1);
        exitInsertSpeakerNameMode();
      } else if (updateAudioSourceMode) {
        const newSpeakerId = (status.transcriptOwners || [])[index - 1];
        const audioStream = status.audioStreams.find(as => as.avaId === newSpeakerId);
        if (audioStream) {
          updateSpeakerListened(audioStream);
        }
        exitUpdateAudioSourceMode();
      } else {
        dispatchSpeakerChangeMutation(index - 1);
      }
    } else if ((!isMac && key.CTRL && key.RETURN && !key.SHIFT) || (isMac && key.META && key.RETURN && !key.SHIFT)) {
      scribeCreateTranscript(selectedTranscriptIndex);
    } else if ((!isMac && key.CTRL && ev.key === 's') || (isMac && key.META && ev.key === 's')) {
      ev.preventDefault();
      ev.stopPropagation();
      splitTranscript({
        selectedWordIndex,
        selectedTranscriptIndex,
      });
    } else if ((!isMac && key.CTRL && key.BACKSPACE) || (isMac && key.META && key.BACKSPACE)) {
      ev.preventDefault();
      ev.stopPropagation();
      ev.preventDefault();
      mergeTranscript({
        selectedTranscriptIndex,
      });
    } else if ((!isMac && key.CTRL && ev.key === 'j') || (isMac && key.META && ev.key === 'j')) {
      ev.preventDefault();
      ev.stopPropagation();
      singletonTrackPlayer.incrementDelay();
    } else if ((!isMac && key.CTRL && ev.key === 'k') || (isMac && key.META && ev.key === 'k')) {
      ev.preventDefault();
      ev.stopPropagation();
      singletonTrackPlayer.decrementDelay();
    } else if ((!isMac && key.CTRL && ev.key === 'u') || (isMac && key.META && ev.key === 'u')) {
      ev.preventDefault();
      ev.stopPropagation();
      singletonTrackPlayer.incrementTinyDelay();
    } else if ((!isMac && key.CTRL && ev.key === 'i') || (isMac && key.META && ev.key === 'i')) {
      ev.preventDefault();
      ev.stopPropagation();
      singletonTrackPlayer.decrementTinyDelay();
    } else if ((!isMac && key.CTRL && ev.key === 'p') || (isMac && key.META && ev.key === 'p')) {
      ev.preventDefault();
      ev.stopPropagation();
      singletonTrackPlayer.playPause();
    } else if ((!isMac && key.CTRL && ev.key === 'g') || (isMac && key.META && ev.key === 'g')) {
      ev.preventDefault();
      ev.stopPropagation();
      singletonTrackPlayer.decreaseGain();
    } else if ((!isMac && key.CTRL && ev.key === 'h') || (isMac && key.META && ev.key === 'h')) {
      ev.preventDefault();
      ev.stopPropagation();
      singletonTrackPlayer.increaseGain();
    }
  };

  unsubscribeFromKeydownEvents() {
    document.removeEventListener('keydown', this.handleKeydown, false);
  }

  subscribeToKeydownEvents() {
    document.addEventListener('keydown', this.handleKeydown, false);
  }

  componentWillUnmount() {
    this.unsubscribeFromKeydownEvents();
  }

  componentDidMount() {
    this.subscribeToKeydownEvents();
  }

  render() {
    return null;
  }
}
